<template>
    <v-app>
        <similar-ads ref="newsAdds"></similar-ads>
        <div class="col-md-8 mx-auto">
            <v-text-field v-if="AuthIs" outlined clearable label="نام مستعار"
                          dense clear-icon="mdi-close-circle-outline"
                          append-inner-icon="fa fa-pencil-alt"
                          v-model="newSchema.smart_payload['nickName']"
                          :error-messages="newSchema.smart_payload['nickName'] === '' ? 'تا زمانیکه نام مستعار وارد نشود قادر به ثبت دسته خود نیستید!' : ''"
            >
            </v-text-field>
            <v-btn class="float-left submit-btn"
                      @click="submit">
                <span class="fa fa-save ml-2 " style="font-size: 1.5rem"></span>
                ثبت
            </v-btn>
        </div>
    </v-app>
</template>

<script>
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import {Bus} from "@/main";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
    name: "AddNews",
    components: {ButtonTempl, SimilarAds},
    data() {
        return {
            AuthIs: false,
            nickName: '',
            newSchema: {
                type: "advertise",
                kind: "new",
                search_payload: {},
                smart_payload: {},
            },
        }
    },
    methods: {
        submit() {
            const data = this.newSchema
            if (this.$refs.newsAdds.$refs.city.validate())
                return;

            $.ajax({
                url: `${url}/smarts`,
                method: 'POST',
                fn: this.submit,
                headers: {
                    ACCEPT: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: Token
                },
                data: JSON.stringify(data),
                msg:true,
                redirect: {path: "/adsList/divarNews/list"}
            });
        }
    },
    mounted() {
        Bus.$on('correctAuth', (value) => {
            this.AuthIs = value
        });
        Bus.$on('getSimilarData', (value) => {

            this.newSchema.search_payload = value
        })
    },
}
</script>

<style scoped>

</style>